export default __webpack_public_path__ + "static/media/Work_71.a9426038.png";